"use strict";

export function initInScope ($scope) {
    $scope.find('.js-cart-benefits__item-cta').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.js-cart-benefits__item').find('form').submit();
    });

}